export function base64EncodeUint8(uint8array: Uint8Array): string {
  let binary = '';
  uint8array.forEach((b) => (binary += String.fromCharCode(b)));
  return btoa(binary);
}

export function base64EncodeJson(value: unknown): string {
  return base64EncodeUint8(new TextEncoder().encode(JSON.stringify(value)));
}

export function base64DecodeToJson(base64Str: string): unknown {
  const binaryStr = atob(base64Str);
  const len = binaryStr.length;
  const bytes = new Uint8Array(len);

  for (let i = 0; i < len; i++) {
    bytes[i] = binaryStr.charCodeAt(i);
  }

  const jsonStr = new TextDecoder().decode(bytes);
  return JSON.parse(jsonStr);
}
